/**
 * SILVIFY — sticky mobile "Add to Bag" bar.
 *
 * Deliberately not a custom element / Component subclass: this mirrors the
 * real buy button rather than owning any cart logic, so it stays a small,
 * standalone script. It reads the real button's current price/CTA text and
 * forwards clicks to it — the real button still does all the work (variant
 * validation, loading state, cart request) so there is nothing to keep in
 * sync beyond what's displayed.
 */
(function () {
  function findRealButton() {
    var candidates = document.querySelectorAll('.luxury-add-to-bag-button:not(.silvify-sticky-bar__button)');
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      // Skip any instance rendered inside a quick-add dialog for a different product.
      if (el.closest('dialog') || el.closest('.quick-add-modal')) continue;
      return el;
    }
    return null;
  }

  function init() {
    var bar = document.querySelector('.silvify-sticky-bar');
    var realButton = findRealButton();
    if (!bar || !realButton) return;

    var barButton = bar.querySelector('.silvify-sticky-bar__button');
    var barPrice = bar.querySelector('.silvify-sticky-bar__price');
    var barText = bar.querySelector('.silvify-sticky-bar__text');
    if (!barButton) return;

    function sync() {
      var priceEl = realButton.querySelector('.luxury-add-to-bag__price');
      // The real button also shows a secondary "Checkout in USD" line under the
      // price (see snippets/price.liquid's .price-usd-alongside) — useful there,
      // clutter in this compact bar, so prefer just the primary price stack.
      var primaryPrice = priceEl ? priceEl.querySelector('.price-stack__primary') : null;
      var textEl = realButton.querySelector('.luxury-add-to-bag__text');
      if (barPrice) barPrice.innerHTML = (primaryPrice || priceEl || {}).innerHTML || '';
      if (textEl && barText) barText.textContent = textEl.textContent;
      barButton.disabled = realButton.disabled;
      barButton.setAttribute('data-loading', realButton.getAttribute('data-loading') || 'false');
    }

    sync();

    // The real button's price/text/disabled state change on variant swaps and
    // add-to-cart loading — mirror it rather than re-deriving it independently.
    var observer = new MutationObserver(sync);
    observer.observe(realButton, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['disabled', 'data-loading'],
    });

    barButton.addEventListener('click', function () {
      realButton.click();
    });

    var mobileQuery = window.matchMedia('(max-width: 749px)');

    var intersectionObserver = new IntersectionObserver(
      function (entries) {
        var entry = entries[entries.length - 1];
        if (!mobileQuery.matches) {
          bar.hidden = true;
          return;
        }
        // Show only once the real button has been scrolled past (its box is
        // fully above the viewport) — not before it's been reached at all.
        var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        bar.hidden = !scrolledPast;
      },
      { threshold: 0 }
    );
    intersectionObserver.observe(realButton);

    mobileQuery.addEventListener('change', function (event) {
      if (!event.matches) bar.hidden = true;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
